export const QR_APP_BANNER_LAST_CLOSED = 'qrAppBannerLastClosed';
export const QR_APP_BANNER_CLOSE_COUNT = 'qrAppBannerCloseCount';
export const QR_APP_BANNER_CLOSED = 'qrAppBannerClosed';
export const QR_APP_BANNER_PHONE_IMAGE_SRC =
  'https://images-static.naikaa.com/media/wysiwyg/uiTools/2025-6/Phone.svg';
